module.exports = __webpack_public_path__ + "img/close-3.2731bfc3.png";